import { useQuery } from '@tanstack/react-query'
import { apiClient } from '@/services/api/client'

interface AdminDashboardConfig {
  admin_list_limit_teachers: number
  admin_list_limit_admins: number
  admin_list_limit_substitutions: number
  admin_list_limit_audit_logs: number
  admin_search_limit_teachers: number
  admin_card_show_cascade_preview: boolean
  admin_card_disclose_candidate_codes: boolean
  admin_card_preview_max_teachers: number
  admin_card_max_visible_badges: number
  admin_card_auto_refresh_preview: boolean
}

const fetchAdminDashboardConfig = async (): Promise<AdminDashboardConfig> => {
  const res = await apiClient.get('/api/v1/admin/config/admin_dashboard')
  return res.data.config
}

export function useAdminDashboardConfig() {
  return useQuery({
    queryKey: ['admin-dashboard-config'],
    queryFn: fetchAdminDashboardConfig,
    staleTime: 5 * 60 * 1000,
  })
}
